<template>
  <section class="faq">
    <section class="faq_detail">
      <div class="faq_page">
        <component :is="target"></component>
      </div>
    </section>
  </section>
</template>

<script>
import faq_20101 from "@/components/FAQ/ios/faq_20101.vue";
import faq_20102 from "@/components/FAQ/ios/faq_20102.vue";
import faq_20103 from "@/components/FAQ/ios/faq_20103.vue";
import faq_20104 from "@/components/FAQ/ios/faq_20104.vue";
import faq_20201 from "@/components/FAQ/ios/faq_20201.vue";
import faq_20202 from "@/components/FAQ/ios/faq_20202.vue";
import faq_20301 from "@/components/FAQ/ios/faq_20301.vue";
import faq_20302 from "@/components/FAQ/ios/faq_20302.vue";
import faq_20303 from "@/components/FAQ/ios/faq_20303.vue";
import faq_20304 from "@/components/FAQ/ios/faq_20304.vue";
import faq_20305 from "@/components/FAQ/ios/faq_20305.vue";
import faq_20306 from "@/components/FAQ/ios/faq_20306.vue";
import faq_20307 from "@/components/FAQ/ios/faq_20307.vue";
import faq_20308 from "@/components/FAQ/ios/faq_20308.vue";
import faq_20401 from "@/components/FAQ/ios/faq_20401.vue";
import faq_20402 from "@/components/FAQ/ios/faq_20402.vue";
import faq_20403 from "@/components/FAQ/ios/faq_20403.vue";
import faq_20404 from "@/components/FAQ/ios/faq_20404.vue";
import faq_20405 from "@/components/FAQ/ios/faq_20405.vue";
import faq_20406 from "@/components/FAQ/ios/faq_20406.vue";
import faq_20407 from "@/components/FAQ/ios/faq_20407.vue";
import faq_20408 from "@/components/FAQ/ios/faq_20408.vue";
import faq_20409 from "@/components/FAQ/ios/faq_20409.vue";
import faq_20410 from "@/components/FAQ/ios/faq_20410.vue";
import faq_20411 from "@/components/FAQ/ios/faq_20411.vue";
import faq_20412 from "@/components/FAQ/ios/faq_20412.vue";
import faq_20413 from "@/components/FAQ/ios/faq_20413.vue";
import faq_20414 from "@/components/FAQ/ios/faq_20414.vue";
import faq_20415 from "@/components/FAQ/ios/faq_20415.vue";
import faq_20416 from "@/components/FAQ/ios/faq_20416.vue";
import faq_20417 from "@/components/FAQ/ios/faq_20417.vue";
import faq_20418 from "@/components/FAQ/ios/faq_20418.vue";
import faq_20501 from "@/components/FAQ/ios/faq_20501.vue";
import faq_20502 from "@/components/FAQ/ios/faq_20502.vue";
import faq_20503 from "@/components/FAQ/ios/faq_20503.vue";
import faq_20504 from "@/components/FAQ/ios/faq_20504.vue";
import faq_20601 from "@/components/FAQ/ios/faq_20601.vue";
import faq_20602 from "@/components/FAQ/ios/faq_20602.vue";
import faq_20701 from "@/components/FAQ/ios/faq_20701.vue";
import faq_20702 from "@/components/FAQ/ios/faq_20702.vue";
import faq_20703 from "@/components/FAQ/ios/faq_20703.vue";
import faq_20704 from "@/components/FAQ/ios/faq_20704.vue";
import faq_20705 from "@/components/FAQ/ios/faq_20705.vue";
import faq_20706 from "@/components/FAQ/ios/faq_20706.vue";
import faq_20707 from "@/components/FAQ/ios/faq_20707.vue";
import faq_20708 from "@/components/FAQ/ios/faq_20708.vue";
import faq_20801 from "@/components/FAQ/ios/faq_20801.vue";
import faq_20802 from "@/components/FAQ/ios/faq_20802.vue";
import faq_20803 from "@/components/FAQ/ios/faq_20803.vue";
import faq_20804 from "@/components/FAQ/ios/faq_20804.vue";
import faq_20805 from "@/components/FAQ/ios/faq_20805.vue";

import faq_10101 from "@/components/FAQ/android/faq_10101.vue";
import faq_10102 from "@/components/FAQ/android/faq_10102.vue";
import faq_10103 from "@/components/FAQ/android/faq_10103.vue";
import faq_10104 from "@/components/FAQ/android/faq_10104.vue";
import faq_10201 from "@/components/FAQ/android/faq_10201.vue";
import faq_10202 from "@/components/FAQ/android/faq_10202.vue";
import faq_10301 from "@/components/FAQ/android/faq_10301.vue";
import faq_10302 from "@/components/FAQ/android/faq_10302.vue";
import faq_10303 from "@/components/FAQ/android/faq_10303.vue";
import faq_10304 from "@/components/FAQ/android/faq_10304.vue";
import faq_10305 from "@/components/FAQ/android/faq_10305.vue";
import faq_10306 from "@/components/FAQ/android/faq_10306.vue";
import faq_10307 from "@/components/FAQ/android/faq_10307.vue";
import faq_10308 from "@/components/FAQ/android/faq_10308.vue";
import faq_10401 from "@/components/FAQ/android/faq_10401.vue";
import faq_10402 from "@/components/FAQ/android/faq_10402.vue";
import faq_10403 from "@/components/FAQ/android/faq_10403.vue";
import faq_10404 from "@/components/FAQ/android/faq_10404.vue";
import faq_10405 from "@/components/FAQ/android/faq_10405.vue";
import faq_10406 from "@/components/FAQ/android/faq_10406.vue";
import faq_10407 from "@/components/FAQ/android/faq_10407.vue";
import faq_10408 from "@/components/FAQ/android/faq_10408.vue";
import faq_10409 from "@/components/FAQ/android/faq_10409.vue";
import faq_10410 from "@/components/FAQ/android/faq_10410.vue";
import faq_10411 from "@/components/FAQ/android/faq_10411.vue";
import faq_10412 from "@/components/FAQ/android/faq_10412.vue";
import faq_10413 from "@/components/FAQ/android/faq_10413.vue";
import faq_10414 from "@/components/FAQ/android/faq_10414.vue";
import faq_10415 from "@/components/FAQ/android/faq_10415.vue";
import faq_10416 from "@/components/FAQ/android/faq_10416.vue";
import faq_10417 from "@/components/FAQ/android/faq_10417.vue";
import faq_10501 from "@/components/FAQ/android/faq_10501.vue";
import faq_10502 from "@/components/FAQ/android/faq_10502.vue";
import faq_10503 from "@/components/FAQ/android/faq_10503.vue";
import faq_10504 from "@/components/FAQ/android/faq_10504.vue";
import faq_10601 from "@/components/FAQ/android/faq_10601.vue";
import faq_10602 from "@/components/FAQ/android/faq_10602.vue";
import faq_10701 from "@/components/FAQ/android/faq_10701.vue";
import faq_10702 from "@/components/FAQ/android/faq_10702.vue";
import faq_10703 from "@/components/FAQ/android/faq_10703.vue";
import faq_10704 from "@/components/FAQ/android/faq_10704.vue";
import faq_10705 from "@/components/FAQ/android/faq_10705.vue";
import faq_10706 from "@/components/FAQ/android/faq_10706.vue";
import faq_10707 from "@/components/FAQ/android/faq_10707.vue";
import faq_10708 from "@/components/FAQ/android/faq_10708.vue";
import faq_10801 from "@/components/FAQ/android/faq_10801.vue";
import faq_10802 from "@/components/FAQ/android/faq_10802.vue";
import faq_10803 from "@/components/FAQ/android/faq_10803.vue";
import faq_10804 from "@/components/FAQ/android/faq_10804.vue";
import faq_10805 from "@/components/FAQ/android/faq_10805.vue";
import faq_10001 from "@/components/FAQ/android/huawei_9.0.vue";
import faq_10002 from "@/components/FAQ/android/huawei_8.0.vue";
import faq_10003 from "@/components/FAQ/android/huawei_7.0.vue";
import faq_10004 from "@/components/FAQ/android/huawei_6.0.vue";
import faq_10005 from "@/components/FAQ/android/huawei_5.1.vue";
import faq_10006 from "@/components/FAQ/android/samsung_9.0.vue";
import faq_10007 from "@/components/FAQ/android/xiaomi_9.0.vue";
import faq_10008 from "@/components/FAQ/android/other.vue";

const previewLinkImg = require("../assets/img/missing calls.png");
export default {
  metaInfo() {
    return {
      title: "FAQ - ToTok Messenger",
      meta: [
        {
          Description: "How to avoid missing new calls on ToTok",
        },
        { property: "og:title", content: "FAQ - ToTok Messenger" },
        {
          property: "og:url",
          content: "https://www.totok.ai/faq/android/10001",
        },
        { property: "og:type", content: "website" },
        { property: "og:image", content: previewLinkImg },
        {
          property: "og:description",
          content: "How to avoid missing new calls on ToTok",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    faq_20101,
    faq_20102,
    faq_20103,
    faq_20104,
    faq_20201,
    faq_20202,
    faq_20301,
    faq_20302,
    faq_20303,
    faq_20304,
    faq_20305,
    faq_20306,
    faq_20307,
    faq_20308,
    faq_20401,
    faq_20402,
    faq_20403,
    faq_20404,
    faq_20405,
    faq_20406,
    faq_20407,
    faq_20408,
    faq_20409,
    faq_20410,
    faq_20411,
    faq_20412,
    faq_20413,
    faq_20414,
    faq_20415,
    faq_20416,
    faq_20417,
    faq_20418,
    faq_20501,
    faq_20502,
    faq_20503,
    faq_20504,
    faq_20601,
    faq_20602,
    faq_20701,
    faq_20702,
    faq_20703,
    faq_20704,
    faq_20705,
    faq_20706,
    faq_20707,
    faq_20708,
    faq_20801,
    faq_20802,
    faq_20803,
    faq_20804,
    faq_20805,
    faq_10101,
    faq_10102,
    faq_10103,
    faq_10104,
    faq_10201,
    faq_10202,
    faq_10301,
    faq_10302,
    faq_10303,
    faq_10304,
    faq_10305,
    faq_10306,
    faq_10307,
    faq_10308,
    faq_10401,
    faq_10402,
    faq_10403,
    faq_10404,
    faq_10405,
    faq_10406,
    faq_10407,
    faq_10408,
    faq_10409,
    faq_10410,
    faq_10411,
    faq_10412,
    faq_10413,
    faq_10414,
    faq_10415,
    faq_10416,
    faq_10417,
    faq_10501,
    faq_10502,
    faq_10503,
    faq_10504,
    faq_10601,
    faq_10602,
    faq_10701,
    faq_10702,
    faq_10703,
    faq_10704,
    faq_10705,
    faq_10706,
    faq_10707,
    faq_10708,
    faq_10801,
    faq_10802,
    faq_10803,
    faq_10804,
    faq_10805,
    faq_10001,
    faq_10002,
    faq_10003,
    faq_10004,
    faq_10005,
    faq_10006,
    faq_10007,
    faq_10008,
  },
  data() {
    return {
      target: "",
    };
  },
  created() {
    // console.log(this.$route.params);
    if (!this.$route.params.target) {
      this.$router.push("faq");
      // window.location.href = '/faq/'
    } else {
      this.target = "faq_" + this.$route.params.target;
    }
  },
  computed: {},
  methods: {},
};
</script>
<style lang="stylus">

@media only screen and (max-width: 700px) {
    .faq_detail {
        padding-top: 1.1rem;

        .faq_page {
            margin-left: 20px;
            margin-right: 20px;
            margin-bottom: 80px;

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 36px;
                padding-top: 40px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 22px;
                font-weight: 400;
                color: #4378f2;
                padding-top: 23px;
                padding-bottom: 16px;
                margin: 0;
            }

            h4 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 19px;
                font-weight: 400;
                color: #000000;
                padding-top: 20px;
                padding-bottom: 13px;
                margin: 0;

            }

            h6 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 15px;
                font-weight: 400;
                color: #999999;
                margin-top: 0px;
                margin-bottom: 10px;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 22px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
            }

            ol {
                list-style: decimal;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 22px;
                margin-left: 20px;
            }

            .header {
                height: 100px;
                background: #4378f2;
            }

            .page {
                max-width: 768px;
                display: flex;
                margin-bottom: 100px
            }

            .screen_shot {
                border-color: #3a8ee6;
                border-width: 1px;
                border-style: solid;
                margin: 20px;
            }
        }

    }

}

@media only screen and (min-width: 701px) {
    .faq_detail {
        padding-top: 5rem;
        margin: 0 auto;
        width: 994px;

        .faq_page {
            margin-left: 20px;
            margin-right: 20px;
            margin-bottom: 80px;

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 36px;
                padding-top: 40px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 22px;
                font-weight: 400;
                color: #4378f2;
                padding-top: 23px;
                padding-bottom: 16px;
                margin: 0;
            }

            h4 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 19px;
                font-weight: 400;
                color: #000000;
                padding-top: 20px;
                padding-bottom: 13px;
                margin: 0;

            }

            h6 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 15px;
                font-weight: 400;
                color: #999999;
                margin-top: 0px;
                margin-bottom: 10px;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 22px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
            }

            ol {
                list-style: decimal;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 22px;
                margin-left: 20px;
            }

            .header {
                height: 100px;
                background: #4378f2;
            }

            .page {
                max-width: 768px;
                display: flex;
                margin-bottom: 100px
            }

            .screen_shot {
                border-color: #3a8ee6;
                border-width: 1px;
                border-style: solid;
                margin: 20px;
            }
        }
    }
}
</style>
